const SET_DISMISSED_MESSAGE_IDS = 'shared/SET_DISMISSED_MESSAGE_IDS';

const initialState = {
  dismissedMessageIds: [],
};

export default function reachoutReducer(state = initialState, action = {}) {
    switch (action.type) {
      case SET_DISMISSED_MESSAGE_IDS:
        return {
          ...state,
          dismissedMessageIds: action.payload || [],
        };

      default:
        return state;
    }
}

function setDismissedMessageIds(Ids) {
  return {
    type: SET_DISMISSED_MESSAGE_IDS,
    payload: Ids,
  };
}

const actions = {
  setDismissedMessageIds,
};

export { actions };



// WEBPACK FOOTER //
// ./src/portfolio-shared/state/reducers/reachoutReducer.js